import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment.prod";

export class ImageComponent {
  image: HTMLImageElement;
  size: number;
}

@Injectable()
export class ResourceManager {

  bytesTotal: number;
  bytesRemaining: number;
  queuedDownloads: number;
  isDownloading = false;
  isInitalized = false;
  isDefaultLoaded = false;

  constructor() {
    this.bytesTotal = 0;
    this.bytesRemaining = 0;
    this.queuedDownloads = 0;
    this.isInitalized = false;
  }

  private images = new Map<string, ImageComponent>();

  clearResources() {
    this.images.clear();
  }

  loadDefaultImages() {
    // Logo
    this.addImage("logo", environment.theme.logo, 2000);
    //this.addImage("SC-Image", environment.theme.defaultSCImage, 2000);

    // Icons
    this.addImage("favorite-icon", environment.theme.favoriteIcon, 2000);
    this.addImage("unfavorite-icon", environment.theme.unfavoriteIcon, 2000);
    this.addImage("info-icon", environment.theme.infoIcon, 2000);
    this.addImage("tag-icon", environment.theme.tagIcon, 2000);
    this.addImage("back-button", environment.theme.backIcon, 2000);
    this.addImage("exchange-icon", environment.theme.flipIcon, 2000);
    this.addImage("newOption-icon", environment.theme.newOptionIcon, 2000);
    this.isDefaultLoaded = true;

  }

  addImage(key: string, url: string, size: number) {

    if (this.images.get(key)) {
      this.images.delete(key);
    }
    this.bytesTotal += size;
    this.bytesRemaining += size;

    const img = new Image();

    img.onload = () => {
      this.queuedDownloads--;

      this.bytesRemaining -= this.images.get(key).size;

      if (this.queuedDownloads === 0) {
        this.isDownloading = false;
      }
    };

    img.onerror = () => {
      img.src = "assets/images/image-unavailable.png";
    };

    const imgComp = new ImageComponent();
    imgComp.image = img;
    imgComp.size = size;

    this.images.set(key, imgComp);
    this.isDownloading = true;
    this.queuedDownloads++;
    img.src = url;
    this.isInitalized = true;
  }

  getImage(key: string): HTMLImageElement {
    if (!this.images) {
      return;
    }
    if (this.images.get(key)) {
      let img = this.images.get(key);
      if (img) {
        return  img.image;       
      }
      return;
    }
  }
  removeImage(key: string) {
    if (!this.images && this.images.get(key)) {
      this.images.delete(key);
    }
  }
}
